<template>
    <dv-percent-pond :config="rateConfig" class="h-100"/>
</template>

<script>
import {_pxGenerator} from "@/components/LayoutMaps/maps/MapFunction";

export default {
    name: "CommonRate",
    props: {
        rate: {
            type: Number,
            default: 0
        }
    },
    computed: {
        rateConfig() {
            return {
                value: (this.rate).toFixed(1),
                borderWidth: _pxGenerator(0.05),
                borderRadius: _pxGenerator(0.1),
                borderGap: _pxGenerator(0.1)
            }
        }
    }
}
</script>

<style scoped>

</style>